<template>
	<v-menu v-if="open" v-model="open" :close-on-content-click="false" :activator="element" offset-x>
		<v-card min-width="500px" flat>
			<v-toolbar :color="event.color" dark>
				<!-- <v-btn icon> -->
				<!-- <v-icon>mdi-pencil</v-icon> -->
				<!-- </v-btn> -->
				<v-toolbar-title class="d-flex align-center">
					{{ booking.user.name }}
					<span class="pl-5 subtitle-2">{{ booking.begin_time }} - {{ booking.end_time }}</span>
					<span class="caption">/{{ booking.actually_to }}</span>
					<span class="pl-5 subtitle-2">{{ $n(booking.price, 'currency') }}</span>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon v-if="booking.can_cancel" @click="confirmDialog = true">
					<v-icon>mdi-cancel</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text>
				<div class="d-flex align-center body-1">
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-icon class="pr-5" :color="userIconColor" v-on="on">{{ userIcon }}</v-icon>
						</template>
						<span>{{ $t('user.types.' + booking.user.type) }} {{ $t('user.states.' + booking.user.state) }}</span>
					</v-tooltip>
					{{ booking.user.name }}
				</div>
				<div class="d-flex align-center body-1"><v-icon class="pr-5">mdi-at</v-icon>{{ booking.user.email }}</div>
				<div class="d-flex align-center body-1"><v-icon class="pr-5">mdi-cellphone-iphone</v-icon>{{ booking.user.phone }}</div>

				<v-divider class="my-3"></v-divider>

				<div class="d-flex align-center">
					<v-chip class="mr-2" label v-for="service in booking.services" :key="service.id">
						<v-icon left>{{ icon[service.type] }}</v-icon>
						{{ service.name }}
					</v-chip>
				</div>
			</v-card-text>
		</v-card>

		<v-dialog v-model="confirmDialog" max-width="290">
			<v-card flat :loading="canceling">
				<v-toolbar color="warning" dark>
					<v-toolbar-title>
						{{ $t('booking.cancel') }}
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="confirmDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card-text class="pt-4">
					{{ $t('booking.cancel_message') }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="warning" @click="cancel" :loading="canceling">{{ $t('ok') }}</v-btn>
				</v-card-actions>
			</v-card>

			<v-snackbar v-model="snackbar" bottom color="error" left>
				{{ snackbarText }}
				<v-btn dark text @click="snackbar = false">
					{{ $t('close') }}
				</v-btn>
			</v-snackbar>
		</v-dialog>
	</v-menu>
</template>

<script>
import { mapMutations } from 'vuex'
import serviceMixin from '~/mixins/serviceMixin'
export default {
	name: 'BookingDetail',

	mixins: [serviceMixin],

	data() {
		return {
			booking: {},
			event: {},
			element: null,
			open: false,
			canceling: false,
			snackbar: false,
			snackbarText: null,
			confirmDialog: false
		}
	},

	computed: {
		userIconColor() {
			if (this.booking.user.state === 'verifed') {
				return 'success'
			}
			return 'red'
		},
		userIcon() {
			if (this.booking.user.type === 'user') {
				if (this.booking.user.state === 'verifed') {
					return 'mdi-account-check'
				}
				return 'mdi-account-alert'
			}
			if (this.booking.user.type === 'guest') {
				return 'mdi-ghost'
			}
			return 'mdi-account-question'
		}
	},

	methods: {
		...mapMutations({
			updateBooking: 'bookings/UPDATE_BOOKING'
		}),
		showDetail({ nativeEvent, event }) {
			const open = () => {
				this.booking = event.booking

				this.event = event
				this.element = nativeEvent.target
				setTimeout(() => (this.open = true), 10)
			}

			if (this.open) {
				this.open = false
				setTimeout(open, 10)
			} else {
				open()
			}

			nativeEvent.stopPropagation()
		},

		async cancel() {
			this.canceling = 'warning darken-1'

			try {
				let { data } = await this.$http.delete(`booking/${this.booking.id}`)
				this.booking.state = data
				this.booking.can_cancel = false
				this.updateBooking(this.booking)
				this.confirmDialog = false
			} catch ({ response }) {
				this.snackbarText = response.data.message
				this.snackbar = true
			}
			this.canceling = false
		}
	}
}
</script>

<style lang="scss" scoped></style>
